import { Route } from '@angular/router';

import { cricketTacticsGameRoutes } from './cricket-tactics/games-cricket-tactics.routes';
import { gamesOnlineLeaveBusterGuard } from './guards/games-online-leave-buster.guard';
import { matchGameRoutes } from './match/games-match.routes';

export const gameRoutes: Route[] = [
    {
        path: 'online-game/killer',
        data: { hideTournamentNotification: true },
        canDeactivate: [gamesOnlineLeaveBusterGuard],
        loadComponent: () =>
            import('../online-games/games/killer/pages/killer-online-gameplay/killer-online-gameplay.component').then(
                (c) => c.KillerOnlineGameplayComponent
            ),
    },
    ...matchGameRoutes,
    ...cricketTacticsGameRoutes,
];
